module.exports = __webpack_public_path__ + "static/media/westpac.c90bf853.png";